export default "__VITE_ASSET__DJS2F9_i__"